export default __webpack_public_path__ + "static/media/Hum.80c45383.svg";